import { get } from "lodash";

export const ERROR_TYPE = {
    NETWORK: "NETWORK",
    JS_ERROR: "JS_ERROR",
};


export function createError(e) {
    if(e == null) {
        return null;
    }
    const response = get(e, "status", null);
    if (response) {
        return netError(e);
    } else {
        return jsError(e);
    }
}
export function jsError(error) {
    return {
        type: ERROR_TYPE.JS_ERROR,
        error,
    };
}
export function netError(error) {
    const code = get(error, "response.status", 500);
    const serverMessage = get(error, "response.statusText", "");
    const data = get(error, "response.data", null);
    const title = get(data, "error", "Server error. Please contact support if the error persists");
    const details = get(data, "errorDetails", null);
    const messageError = get(error, "message", "Unknown error please contact the administrator");
    const message = get(data, "message", messageError);
    return {
        serverMessage,
        message,
        details,
        data,
        code,
        error,
        title,
        type: ERROR_TYPE.NETWORK,
    };
}

export function handleServerErrors(error, callback) {
    const status = error?.response?.status;
    if(!status || status === 406) {
        callback(error);
    }
}
